import StudyPlan from './model';
import create from './create';

StudyPlan.create = create;

export default StudyPlan;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/StudyPlan/result/index.js